const resolveApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;

  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    if (hostname === '127.0.0.1' || hostname === 'localhost') {
      return protocol + '//' + hostname + ':15000';
    }

    if (/^192\.168\./.test(hostname)) {
      return protocol + '//' + hostname + ':5000';
    }
  }

  return envUrl || 'https://tzone-web-backend-1-2ev5.onrender.com';
};

const API_BASE_URL = resolveApiBaseUrl();

export default API_BASE_URL;
